import {
    FETCH_MODALITY_TYPES,
    FETCH_MODALITY_TYPES_SUCCESS,
    FETCH_MODALITY_TYPES_ERROR
} from '../../actions/common/modality-action';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    modalityTypes: JSON.parse(localStorage.getItem('modalityTypes')) || []
};

const modalityReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_MODALITY_TYPES: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_MODALITY_TYPES_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, modalityTypes: action.modalityTypes };
        }
        case FETCH_MODALITY_TYPES_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        default:
            return state;
    }
}

export default modalityReducer;
